/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockElements.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Block Element Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, October 01, 2018 - 05:25:15 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      10/01/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockElementForm = Loadable({
    loader: () => import('../containers/BlockElements/BlockElementEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockElements.js